/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  createDialogRoute,
  getDialogInitData,
} from '@gh/common-shared';
import {
  DialogInput,
  EmptyDialogInput,
} from '@gh/core-ui';
import { MobileQrCodeDialogBusinessService } from '../../resources/mobile-qr-code-dialog-business.service';
import { HELP_URL } from '@gh/config';
import { substitute } from '@gh/core-util';

@Component({
  selector: 'gh-mobile-qr-code-dialog',
  template: require('./mobile-qr-code-dialog.component.html'),
  styles: [require('./mobile-qr-code-dialog.component.scss')],
})
export class MobileQrCodeDialogComponent implements OnInit, DialogInput<EmptyDialogInput> {
  input: EmptyDialogInput;
  isDisabled: boolean;
  qrCode: string;

  get helpCenterUrl(): string {
    const path = 'mobile-app-install';
    return substitute(HELP_URL, { path });
  }

  constructor(@Inject(MAT_DIALOG_DATA)
              private dialogData: any,
              private dialogRef: MatDialogRef<any>,
  ) {}

  ngOnInit(): void {
    const { qrCode } = getDialogInitData(this.dialogData);
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.qrCode = e.target.result;
    };

    reader.readAsDataURL(qrCode);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}

export const mobileQRCodeDialogRoute = createDialogRoute({
  component: MobileQrCodeDialogComponent,
  config: { autoFocus: false },
  init: MobileQrCodeDialogBusinessService,
});
